import { gql } from '@apollo/client'

export const REQUEST_PASSWORD_RESET = gql`
  mutation RequestPasswordReset($inputData: RequestPasswordInput!) {
    requestPasswordReset(inputData: $inputData)
  }
`
